import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig";

interface IndexUsersProviderProps {
  children: ReactNode;
  callback?: () => void;
}

interface IndexUsersContextValue {
  modalConfig: ModalConfig;
  setModalConfig: Dispatch<SetStateAction<ModalConfig>>;
  callback?: () => void;
}

const IndexUsersContext = createContext<IndexUsersContextValue | undefined>(
  undefined
);

const IndexUsersProvider: React.FC<IndexUsersProviderProps> = ({
  children,
  callback,
}) => {
  const [modalConfig, setModalConfig] = useState<ModalConfig>(
    createModalConfig()
  );

  return (
    <IndexUsersContext.Provider
      value={{ modalConfig, setModalConfig, callback }}
    >
      {children}
    </IndexUsersContext.Provider>
  );
};

const useIndexUsersContext = (): IndexUsersContextValue | undefined => {
  return useContext(IndexUsersContext);
};

export { IndexUsersProvider, useIndexUsersContext };
